import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-459bb0e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "cut-line"
}
const _hoisted_5 = {
  key: 2,
  class: "subject-list"
}
const _hoisted_6 = { class: "subject-inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "小学", -1))
const _hoisted_8 = { class: "list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "subject-inner middle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "初中", -1))
const _hoisted_12 = { class: "list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "subject-inner" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "高中", -1))
const _hoisted_16 = { class: "list" }
const _hoisted_17 = ["onClick"]

import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeMount,
} from "vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'search-component',
  props: {
  subjectData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  defaultFilterData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  keyWord: {
    type: String,
    default: "",
  },
  pageFrom: {
    type: String,
    default: "",
  },
},
  emits: ["handleSelectSubject", "search"],
  setup(__props, { emit: $emit }) {

const props = __props;

const router = useRouter();

const searchVal = ref("");
const selectSubject = ref({});
const selectSubjectText = ref("小学数学");
const showsubjects = ref(false);
const facultyMap = {
  1: "小学",
  2: "初中",
  3: "高中",
};


const mapSubject = computed(() => {
  return props.subjectData;
});

const handleOpen = () => {
  showsubjects.value = !showsubjects.value;
};
const handleSelectSubject = (index, subject) => {
  showsubjects.value = false;
  selectSubjectText.value = `${facultyMap[index]}${subject.text}`;
  const subjectData = {
    ...subject,
    divisionId: index,
  };
  selectSubject.value = subjectData;
  $emit("handleSelectSubject", subjectData, "select");
};
const clickoutside = () => {
  showsubjects.value = false;
};

const handleSearch = () => {
  $emit("search", encodeURIComponent(searchVal.value));
};
const confirmSearch = (event) => {
  event.target.blur()
  if (props.pageFrom === "home") {
    handleSearch();
  } else {
    // 跳转到首页
    router.replace(`/paper?keyword=${encodeURIComponent(searchVal.value)}`);
  }
};
onMounted(() => {
  // document.addEventListener('keydown', function(event) {
  //   if (event.key === 'Enter') {
  //     // 回车键被按下
  //     confirmSearch()
  //   }
  // })
});
watch(
  () => props.defaultFilterData,
  (val) => {
    if (val) {
      selectSubject.value = val;
      selectSubjectText.value = `${facultyMap[val.divisionId]}${val.text}`;
    }
  },
  {
    immediate: true,
  }
);
watch(
  () => props.keyWord,
  (val) => {
    if (val) {
      searchVal.value = val;
    }
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_clickoutside = _resolveDirective("clickoutside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.pageFrom == 'home')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "subject",
          onClick: handleOpen
        }, [
          (!selectSubjectText.value.includes('undefined'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(selectSubjectText.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "小学数学")),
          _createElementVNode("i", {
            class: _normalizeClass(showsubjects.value ? 'up' : 'down')
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    (__props.pageFrom == 'home')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_el_input, {
      modelValue: searchVal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchVal).value = $event)),
      placeholder: "请输入试卷关键词",
      clearable: "",
      onKeydown: _withKeys(confirmSearch, ["enter"]),
      maxlength: 100,
      onClear: handleSearch,
      class: "input-with-select"
    }, null, 8, ["modelValue", "onKeydown"]),
    _createElementVNode("div", {
      class: "search-btn",
      onClick: confirmSearch
    }, "搜索"),
    (showsubjects.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapSubject.value.subjectPrimary, (subject) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (handleSelectSubject(1, subject)),
                  class: _normalizeClass(
              selectSubject.value.divisionId == 1 &&
              selectSubject.value.value === subject.value
                ? 'active'
                : ''
            ),
                  key: subject.id
                }, _toDisplayString(subject.text), 11, _hoisted_9))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapSubject.value.subjectJunior, (subject) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (handleSelectSubject(2, subject)),
                  class: _normalizeClass(
              selectSubject.value.divisionId == 2 &&
              selectSubject.value.value === subject.value
                ? 'active'
                : ''
            ),
                  key: subject.id
                }, _toDisplayString(subject.text), 11, _hoisted_13))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapSubject.value.subjectSenior, (subject) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: subject.id,
                  class: _normalizeClass(
              selectSubject.value.divisionId == 3 &&
              selectSubject.value.value === subject.value
                ? 'active'
                : ''
            ),
                  onClick: ($event: any) => (handleSelectSubject(3, subject))
                }, _toDisplayString(subject.text), 11, _hoisted_17))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_clickoutside, clickoutside]
  ])
}
}

})